export default __webpack_public_path__ + "static/media/promotion.4815ebf9.svg";